export default __webpack_public_path__ + "static/media/trr-food-pastry-8.424838ad.png";